<template>
  <h3 class="page-headline__section-title">
    {{ title }}
  </h3>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline__section-title {
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 1.6;
}
</style>
